"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsupportedOS = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

exports.UnsupportedOS = function () {
  return {
    title: react_1.default.createElement("div", null, "\u0412\u0430\u0448\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043D\u0435\xA0\u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0434\u043B\u044F\xA0\u0440\u0430\u0431\u043E\u0442\u044B \u0441\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430\u043C\u0438"),
    message: react_1.default.createElement("div", null, "\u0412\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C Windows.")
  };
};